// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"21":"9d81b87c","421":"dac4dd98","837":"887b953b","942":"3990ed16"}[chunkId] + ".css";
};